export const cssVars = {

  // --------- GENERIC STUFF
  white: '#FFFFFF',
  black: '#000000',

  // --------- COLORS
  brand_primary_color: '#00ADEE',
  background_color: '#EDF3FD',
  body_color: '#4a5568',
  heading_color: '#313131',
  blockquote_color: '#313131',
  navigation_link_color: '#8F8F8F',
  border_color: '#E0E0E0',
  footer_background_color: '#202020',
  input_color: '#575757',

  // --------- BOX-SHADOWS

  shadow_md: (
    '0 4px 6px -1px rgba(0, 0, 0, 0.1),'
    + '0 2px 4px -1px rgba(0, 0, 0, 0.06);'
  ),

  shadow_xl: (
    '0 20px 25px -5px rgba(0, 0, 0, 0.1),'
    + '0 10px 10px -5px rgba(0, 0, 0, 0.04);'
  ),

};
